import DeleteRounded from '@material-ui/icons/DeleteRounded';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { GalleryImagePreview } from '.';
import { GalleryImageInfo, removeImgFromGallery } from '../../misc/lib/gallery';
import './GalleryImage.scss';

const GalleryImage = (props: GalleryImageInfo) => {
  const [ confirmDelete, setConfirmDelete ] = useState(false);
  const [ enlarged, setEnlarged ] = useState(false);
  const { pathname } = useLocation();
  const displayAdminTools = useMemo(() => !!pathname.match(/admin/g), [ pathname ]);

  useEffect(() => {
    if (confirmDelete) {
      setTimeout(() => setConfirmDelete(false), 3000);
    }
  }, [ confirmDelete ]);

  useEffect(() => {
    if (enlarged) {
      window.document.body.style.overflowY = 'hidden';
    } else {
      window.document.body.style.overflowY = 'initial';
    }
  }, [ enlarged ]);

  return (
    <Fragment>
      { enlarged ? (
        <GalleryImagePreview onDismiss={ () => {
          setEnlarged(false);
        } } imgUrl={ props.url } />
      ) : null }
      <div className={ `app-gallery-image${ displayAdminTools ? ' admin' : '' }` }>
        <img src={ props.url } alt="" onError={ () => {
          console.error('Failed to load gallery image');
        } } onClick={ () => {
          setEnlarged(true);
        } } />
        { displayAdminTools ? (
          <Fragment>
            <p>
              ID: <b>{ props.id }</b><br />
              Feltöltve: <b>{ props.timestamp.toDate().toLocaleString() }</b>
            </p>
            <button onClick={ () => {
              if (confirmDelete) removeImgFromGallery(props.id).then(() => {
                window.location.reload();
              }).catch((err) => {
                console.error(err);
              }); else setConfirmDelete(true);
            } }>
              <span><DeleteRounded color="inherit" /></span>
              { confirmDelete ? <b>Biztos?</b> : 'Törlés' }
            </button>
          </Fragment>
        ) : null }
      </div>
    </Fragment>
  );
};

export default GalleryImage;
